<template>
  <div class="contacto">
    <div class="dvBanner">
      <!--<img class="img" src="../assets/images/business-card-1026403.jpg"/>-->
      <div class="img" :style="{backgroundImage: 'url(' + imageUrl + ')'}" ></div>
      <div class="text">
        <span>NOS AGRADA <span>RECIBIR SUS</span> COMENTARIOS</span>
      </div>
    </div>

    <div id="contacto">
      <div class="title"><span>Nos encanta recibir tus comentarios.</span></div>
      <div>
        <div class="descripcion">
          <span>Queremos saber tus comentarios o sugerencias.</span>
          <div>
            <img src="../assets/contacto/telfono.svg"/>
            <div>
              <span>7771345032</span>
              <span>7771345032</span>
            </div>
          </div>
          <div>
            <img src="../assets/contacto/mail.svg"/>
            <div>
              <span>contacto@sekaisoft.com.mx</span>
            </div>
          </div>
          <div>
            <img src="../assets/contacto/location.svg" style="margin: 0 4px;"/>
            <div>
              <span><strong>SEKAISOFT S.A. DE C.V.</strong></span>
              <span>Andador Ixtlixochitl 29</span>
              <span>Unidad Morelos, C.P. 6901</span>
              <span>Jojutla, Mor.</span>
            </div>
          </div>
        </div>
        <div class="formulario">
          <div>
            <span>Nombre*</span>
            <input ref="nombre" placeholder="Ingresa tu nombre" @change="onChange('nombre')"/>
          </div>
          <div>
            <span>Correo Electrónico*</span>
            <input ref="correo" placeholder="Ingresa tu correo" @change="onChange('correo')"/>
          </div>
          <div>
            <span>Razón de Contacto</span>
            <input placeholder="Ingresa tu razón de contacto" ref="razon"/>
          </div>
          <div>
            <span>Mensaje*</span>
            <textarea ref="mensaje" placeholder="Ingresa tu mensaje" @change="onChange('mensaje')"/>
          </div>
          <div class="required">
            Campos Obligatorios *
          </div>
          <div class="button" @click="enviar">Enviar</div>

        </div>
      </div>
      <div id="sucess" v-if="modal">
        <span>Enviado con exito</span>
        <div></div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations } from 'vuex'

   export default {
      name: "Contacto",
     created: function () {
       setTimeout( () => {
         this.changeMenu({logo: '', value: 'Contacto', ruta: 'Contacto'});
       }, 200);
       this.$data.modal = false;

       try{
         document.documentElement.scrollTop = 0;
       }catch (e) {
         document.scrollingElement.scrollTop = 0;
       }
     },
     computed: {
       ...mapState([
         'loading'
       ]),
       imageUrl() {
         return require('../assets/images/business-card-1026403-min.jpg');
       }
     },
     methods: {
       ...mapMutations([
         'select_menu',
       ]),
       ...mapActions([
         'enviarCorreo'
       ]),

       changeMenu: function (item) {
         this.select_menu(item.value);
       },

       enviar: function () {
         if (this.validar()) {
           //Holland <atencionclientes@hollandah.com.mx>
           // destinatario: this.$refs.correo.value,
           //   remitente: 'Holland <atencionclientes@hollandah.com.mx>',
           let data = {
             destinatario: 'contacto@sekaisoft.com.mx',
             remitente: this.$refs.correo.value,
             asunto: 'Contacto - Pagina',
             detalles: false,
             html: '<!DOCTYPE html>' +
             '<html lang="en">' +
             '<head>' +
             '  <meta charset="UTF-8">' +
             '</head>' +
             '<body>' +
             '<div style="max-width: 480px;margin: 0 auto;border: 1px solid #F1F1F1; -webkit-box-shadow: 0px 2px 16px 0px #eaeaea !important;-moz-box-shadow: 0px 2px 16px 0px #eaeaea !important;box-shadow: 0px 2px 16px 0px #eaeaea !important;padding: 20px;">' +
             '  <div style="margin-bottom: 50px; display: block;">' +
             '    <img style="width: 93px; display: inline-block;" src="http://sekaisoft.com.mx/sekai2.png">' +
             '    <span style="font-family: Arial-Black; font-size: 28px;color: #333333;letter-spacing: -0.06px; display: inline-block; margin-left: 20px; font-weight: 700;">Solicitud de Contacto</span>' +
             '  </div>' +
             '  <div style="font-family: Arial;font-size: 16px;color: #333333;">' +
             '    <span style="display: block;">Buenas tardes,</span>' +
             '    <span style="display: block;">' +
             'Se ha recibido una solicitud de contacto através del formulario de contacto de Sekaisoft.com.mx' +
             '</span>' +
             '    <span style="margin-top: 25px; display: block;">' +
             'A continuación encontrarás los detalles.' +
             '</span>' +
             '  </div>' +
             '  <div >' +
             '    <div style="padding: 10px;background: #FFFFFF; min-height: 35px;">' +
             '      <table style="font-family: Arial;font-size: 16px;color: #333333;">' +
             '        <tbody>' +
             '        <tr>' +
             '          <td><span style="width: 160px;display: inline-block; vertical-align: sub;font-weight: bold;">Nombre</span></td>' +
             '          <td><span style="display: inline-block; vertical-align: sub;">' + this.$refs.nombre.value + '</span></td>' +
             '        </tr>' +
             '        </tbody>' +
             '      </table>' +
             '    </div>' +
             '    <div style="padding: 10px;background: #F3F3F3; min-height: 35px;">' +
             '      <table style="font-family: Arial;font-size: 16px;color: #333333;">' +
             '        <tbody>' +
             '        <tr>' +
             '          <td><span style="width: 160px;display: inline-block; vertical-align: sub;font-weight: bold;">Correo Electrónico</span></td>' +
             '          <td><span style="display: inline-block; vertical-align: sub;">' + this.$refs.correo.value + '</span></td>' +
             '        </tr>' +
             '        </tbody>' +
             '      </table>' +
             '    </div>' +
             '    <div style="padding: 10px;background: #FFFFFF; min-height: 35px;">' +
             '      <table style="font-family: Arial;font-size: 16px;color: #333333;">' +
             '        <tbody>' +
             '        <tr>' +
             '          <td><span style="width: 160px;display: inline-block; vertical-align: sub;font-weight: bold;">Razón de Contacto</span></td>' +
             '          <td><span style="display: inline-block; vertical-align: sub;">' + (this.$refs.razon.value ? this.$refs.razon.value : 'NA') + '</span></td>' +
             '        </tr>' +
             '        </tbody>' +
             '      </table>' +
             '    </div>' +
             '    <div style="padding: 10px;background: #F3F3F3; min-height: 120px;">' +
             '      <table style="font-family: Arial;font-size: 16px;color: #333333;">' +
             '        <tbody>' +
             '        <tr>' +
             '          <td style="vertical-align: top;"><span style="width: 160px;display: inline-block; vertical-align: sub;font-weight: bold;">Mensaje</span></td>' +
             '          <td><span style="display: inline-block; vertical-align: sub;">' + this.$refs.mensaje.value + '</span></td>' +
             '        </tr>' +
             '        </tbody>' +
             '      </table>' +
             '    </div>' +
             '  </div>' +
             '  <div style="margin-top: 45px; text-align: center;">' +
             '<span style="font-family: Arial;font-size: 14px;color: #99A9B4;text-align: center;">' +
             'Este mensaje fue generado por un sistema automatizado.' +
             'Por favor, no respondas a este mensaje.' +
             '</span>' +
             '  </div>' +
             '<div style="background: #333333; width: 100%; text-align: center; margin-top: 15px;">' +
             //'    <img style="width: 90px; margin: 13.25px;" src="http://201.160.106.178/hollandv2/static/img/logo_ryndem.14df32a.svg">' +
             '  </div>'+
             '</div>' +
             '</body>' +
             '</html>'
           }
           this.enviarCorreo(data);
           this.enviadoConExito();
         }
       },
       enviadoConExito: function () {
         if (this.loading){
           setTimeout(() => {
             this.enviadoConExito();
           },100);
         }
         else {
           this.$data.modal = true;
           this.limpiar('correo');
           this.limpiar('nombre');
           this.limpiar('mensaje');
           this.limpiar('razon');
           setTimeout(() => {
             this.$data.modal = false;
           },1500)
         }
       },
       limpiar: function (id) {
         this.$refs[id].value = '';
       },
       onChange: function (id) {
         let isOK = true;
         if (id === 'correo') {
           if (/^[_a-z0-9-]+(.[_a-z0-9-]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$/.test(this.$refs.correo.value)){
             this.$refs.correo.className = '';
           }else {
             this.$refs.correo.className = 'error';
             isOK = false;
           }
         } else {
           if (this.$refs[id].value && this.$refs[id].value !== '') {
             this.$refs[id].className = '';
           } else {
             this.$refs[id].className = 'error';
             isOK = false;
           }
         }

         return isOK;
       },
       validar: function () {
         console.log((this.onChange('correo') & this.onChange('nombre') & this.onChange('mensaje')));
         return (this.onChange('correo') & this.onChange('nombre') & this.onChange('mensaje'));
       }
     },
     data: function () {
       return {
         modal: false
       }
     }
   }
</script>

<style scoped lang="scss">
  @import "../style/base";

  .contacto {

    & .dvBanner {
      width: 100%;
      max-height: 600px;
      overflow: hidden;
      position: relative;
      & img {
        width: 100%;
      }
      & .img {
        width: 100%;
        height: 500px;
        background-size: 1000px;
        background-position: center;
        background-repeat: no-repeat;

      }
      & .text {
        position: absolute;
        max-width: 800px;
        top: 25%;
        left: 50%;
        text-align: center;
        transform: translate(-50%);
        @include flexRow;
        @include Montserrat;
        @include fontFormat(30px, #ff3464, 900);
        //background: #fefea440;
        @include responsiveFont(42, 0.7);
        & > span  {
          line-height: 1;
          color: #063e69;
         & > span {
           color: red;
         }
        }
      }
    }

    #contacto {
      @include Montserrat;
      margin: 30px 40px;
      *::-ms-backdrop, & {
        margin: 30px 20px;
      }
      text-align: left;
      & > .title {
        @include fontFormat(32px, 700, #F9423A);
        line-height: 32px;
        text-transform: uppercase;
        @include customFont(22, 34);
        text-align: center;
        margin-bottom: 10px;
        & > span {
          width: 100%;
        }
      }

      & > div {
        @include flexColumn;
        align-items: center;

        & > div {
          width: 100%;

          &.descripcion {
            font-size: 18px;
            margin-right: 10px;
            & > div {
              @include flexRow;
              margin-top: 30px;
              position: relative;
              left: 0;
              align-items: center;
              max-width: 318px;
              margin-left: auto;
              margin-right: auto;
              & > div {
                @include flexColumn;
                margin-left: 30px;
              }
            }
            & > span {
              @include fontFormat(16px, 400, #333333);
              line-height: 25.89px;
              @include customFont(18, 19);
              display: block;
              text-align: center;
            }
          }

          &.formulario {
            & > div {
              @include flexColumn;
              margin-top: 20px;
              max-width: 500px;
              margin-left: auto;
              margin-right: auto;
              transition: 1s all cubic-bezier(0.01, 0.03, 0.02, 0.01);
              & > span {
                @include fontFormat(19px, 600, #F9423A);
              }
              & > input, & > textarea {
                margin-top: 5px;
                @include fontFormat(18px, 400, #333333);
                border: none;
                border-bottom: 1px solid #BCBCBC;

                &:HOVER {
                  color: #000000;
                  &::-webkit-input-placeholder {
                    color: #333333;
                  }
                }

                &:FOCUS {
                  color: #000000;
                  &::-webkit-input-placeholder {
                    color: #333333;
                  }
                }

                &.error {
                  border-bottom: 1px solid #F9423A;
                  transition: .75s all cubic-bezier(0.01, 0.03, 0.02, 0.01);
                }
              }

              & > textarea {
                height: 60px;
              }

              &.required {
                @include fontFormat(10px, 600, #333333);
                text-align: right;
                margin: 5px 0;
              }
            }

            & .button {
              @include hollandButton(100%);
              box-shadow: none;
            }

          }
        }
      }

      #sucess {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 999;

        & > span {
          text-align: center;
          position: relative;
          left: 50%;
          box-shadow: 0px 0px 10px 2px #c2c2c2;
          background: #FFFFFF;
          transform: translateX(-50%);
          z-index: 9;
          padding: 10px 20px;
        }

        & > div {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          background: #000000bf;
          height: 100%;
        }
      }

      @include responsive_layout('small') {
        & > div {
          @include flexRow;
          & > div {
            width: 100%;
            &.descripcion {
              & > span:first-of-type {
                text-align: left;
              }
              & > div {
                /*left: 10%;*/
                margin-right: 0;
                margin-left: 0;
              }
            }

            &.formulario {
              & > div {
                margin-right: 0;
                margin-left: 0;
              }
            }
          }
        }
      }
    }

  }

</style>
